@let conf = config();
<div [formGroup]="form" [patchFormGroupWithEmitValues]="conf">
  <div formGroupName="settings" class="flex flex-col">
    <div class="flex flex-row items-center space-x-1">
      <mat-form-field>
        <mat-label
          >{{ 'time-series-identifier.TIME_FRAME' | transloco }}
        </mat-label>
        <mat-select formControlName="timeFrame">
          <mat-option [value]="null" selected
            >{{ 'common.NO_SELECTION' | transloco }}
          </mat-option>
          @for (item of timeFrames$ | async; track item.name) {
            <mat-option value="{{ item.name }}"
              >{{ 'time-span-toggle.' + item.name | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          formControlName="startDate"
          [matDatepicker]="picker"
          [placeholder]="'time-series-identifier.INDEX_START_DATE' | transloco"
        />

        <mat-datepicker-toggle matSuffix (click)="clearStartDate($event)">
          <fa-icon matDatepickerToggleIcon [icon]="faTimes"></fa-icon>
        </mat-datepicker-toggle>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="flex flex-col">
      <span class="label">{{
        'correlation-widget-settings.BASE' | transloco
      }}</span>
      <div class="flex flex-row items-center space-x-1">
        <mat-checkbox formControlName="weeks"
          >{{ 'correlation-widget-settings.WEEKS' | transloco }}
        </mat-checkbox>
        <mat-checkbox formControlName="months"
          >{{ 'correlation-widget-settings.MONTHS' | transloco }}
        </mat-checkbox>
        <mat-checkbox formControlName="years"
          >{{ 'correlation-widget-settings.YEARS' | transloco }}
        </mat-checkbox>
      </div>
    </div>
  </div>
  @if (form.hasError('atLeastOne')) {
    <div style="color: red">
      {{ 'ui-spread-widget.TIME_FRAME_NOT_VALID' | transloco }}
    </div>
  }
  <time-series-dynamic-selection-group
    [formGroup]="form"
    [dataSource]="conf?.dataSources"
  ></time-series-dynamic-selection-group>
  <!-- !TODO: update to v18 -->
  <!-- [calculationType]="calculationType$ | async" -->
</div>
